import React from "react";
import "./styles/About.css";
import { Link } from "react-router-dom";

import profil from "../medias/profil.jpg";

const About = () => {
  return (
    <main className="about-container">
      <section className="about-header">
        <h1>À propos de notre entreprise</h1>
        <p>
          Spécialisé dans les réseaux enterrés et les interventions en voirie,
          nous accompagnons chaque client avec rigueur, transparence et sens du service.
        </p>
      </section>

      <section className="about-intro">
        <img
          src={profil}
          alt="Portrait de l'artisan électricien TP"
          className="about-portrait"
        />
        <div className="about-text">
          <h2>Mon parcours</h2>
          <p>
            Je m'appelle Jordan Da Cunha, gérant de l'entreprise DCTP.  
            Fort de plus de 8 ans d'expérience dans les travaux publics, j'ai évolué sur différents postes, de monteur réseau à conducteur de travaux,
            notamment chez BELMAS TP et RTE.  
            Formé en électrotechnique et en ingénierie technique, j'ai lancé DCTP pour proposer un service réactif, rigoureux et humain,  
            dédié aux projets de géothermie, de réseaux enterrés et d'aménagement VRD, partout en Occitanie et Aquitaine.
          </p>
        </div>
      </section>

      <section className="about-method">
        <h2>Notre méthode de travail</h2>
        <p>
          Chaque intervention est minutieusement préparée : étude du terrain, coordination de chantier, respect des délais.
          Notre engagement : un travail rigoureux, conforme aux normes, réalisé dans le respect total de la sécurité et de la transparence.
        </p>
      </section>

      <section className="about-guarantees">
        <h2>Mes engagements professionnels</h2>
        <ul>
          <li>✅ Assurance décennale professionnelle</li>
          <li>✅ Intervention sur domaine public et privé</li>
          <li>✅ Respect strict des normes (DTU, sécurité, environnement)</li>
        </ul>
      </section>

      <section className="about-quote">
        <blockquote>
          Notre rôle : garantir la sécurité, la fiabilité et la sérénité de nos clients à chaque étape du chantier.”
        </blockquote>
      </section>

      <section className="about-cta">
        <h2>Besoin de discuter de votre projet ?</h2>
        <p>Contactez-nous pour toute question ou demande de devis : nous vous répondons sous 24h.</p>
        <Link to="/contact" className="about-cta-btn">
          Nous contacter
        </Link>
      </section>
    </main>
  );
};

export default About;
